import { borderColor } from '@circlefin/tailwind/extend/colors.border'
import { textColor } from '@circlefin/tailwind/extend/colors.text'

import type { StripeElementsOptions } from '@stripe/stripe-js'

export const elementsOptions: StripeElementsOptions = {
  appearance: {
    variables: {
      colorText: textColor.neutral.strong,
      colorTextPlaceholder: textColor.neutral.subtlest,
      fontFamily: 'Circular, sans-serif',
      spacingUnit: '5px',
      borderRadius: '0.375rem',
      colorDanger: textColor.error,
    },
    rules: {
      '.Input': {
        borderColor: borderColor.neutral.DEFAULT,
        boxShadow: 'none',
        paddingTop: '10px',
        paddingBottom: '10px',
      },
      '.Input--invalid': {
        borderColor: borderColor.error,
      },
      '.Label': {
        color: textColor.neutral.DEFAULT,
        fontSize: '14px',
        fontWeight: '700',
      },
      '.Error': {
        fontSize: '12px',
        lineHeight: '16px',
      },
    },
  },
}
